module.exports = __webpack_public_path__ + "static/media/masthead-geraldton-guardian.bda21453.svg";